import React, { useState, useEffect } from "react";
import { ArrowUp } from "lucide-react";

export default function BackToTop() {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        const onScroll = () => setVisible(window.scrollY > 500);
        window.addEventListener("scroll", onScroll, { passive: true });
        onScroll();
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    const scrollTop = () => window.scrollTo({ top: 0, behavior: "smooth" });

    return (
        <button
            onClick={scrollTop}
            aria-label="Remonter en haut"
            className={`fixed bottom-6 right-6 z-50 w-12 h-12 rounded-full border border-gilt bg-[var(--bg-elev)] text-gilt flex items-center justify-center transition-all duration-300 hover:bg-gilt hover:text-[var(--bg)] ${
                visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4 pointer-events-none"
            }`}
        >
            <ArrowUp size={20} strokeWidth={1.5} />
        </button>
    );
}
